<template>
  <a-layout-content class="p-all">
    <a-spin tip="Halaman sedang diproses!..." :spinning="loading.page">
      <a-card>
        <div slot="title">
          <span class="d-block">Realisasi Surat Perintah Lembur</span>
        </div>
        <a-tag slot="extra" color="red" v-if="mode == 'revised'">{{ mode.toUpperCase() }}</a-tag>
        <a-tag slot="extra" color="green" v-else>{{ mode.toUpperCase() }}</a-tag>

        <a-row :gutter="{ xs: 0, lg: 8 }">
          <a-col :xs="24" :lg="12">
            <a-card title="Informasi">
              <a-form class="m-form" :form="form">
                <a-form-item label="SPL">
                  <a-select showSearch v-decorator="['spl_id', { rules: [{ required: true }] }]" @change="changeSPL"
                    placeholder="Pilih No. SPL" :disabled="loading.splLoading || mode == 'Edit'"
                    :filter-option="filterOption">
                    <a-icon slot="suffixIcon" type="loading" v-if="loading.splLoading" />
                    <a-select-option v-for="item in basedData.splList" :key="item.spl_id" :disabled="datasource.length > 0">
                      {{ item.spl_no }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-form>
              <a-row :gutter="16" class="m-top">
                <a-col :xs="24" :lg="12">
                  <li class="m-remove">
                    <span class="list-title">Tanggal</span>
                    <span class="list-desc">{{ basedData.spl.create_dt ? basedData.spl.create_dt : '-' }}</span>
                  </li>
                </a-col>
                <a-col :xs="24" :lg="12">
                  <li class="m-remove">
                    <span class="list-title">Pembuat</span>
                    <span class="list-desc">{{ basedData.spl.tlc_create ? basedData.spl.tlc_create : "-" }}</span>
                  </li>
                </a-col>
              </a-row>
              <a-row :gutter="16" class="m-top">
                <a-col :xs="24" :lg="12">
                  <li class="m-remove">
                    <span class="list-title">TLC Pelaksana</span>
                    <span class="list-desc">{{ basedData.spl.pelaksana ? basedData.spl.pelaksana : "-" }}</span>
                  </li>
                </a-col>
                <a-col :xs="24" :lg="12">
                  <li class="m-remove">
                    <span class="list-title">Kode Proyek</span>
                    <span class="list-desc">{{ basedData.spl.c_proyek ? basedData.spl.c_proyek : "-" }}</span>
                  </li>
                </a-col>
              </a-row>
              <a-row :gutter="16" class="m-top">
                <a-col :xs="24" :lg="24">
                  <li class="m-remove">
                    <span class="list-title">Uraian Tugas</span>
                    <span class="list-desc">{{ basedData.spl.uraian ? basedData.spl.uraian : "-" }}</span>
                  </li>
                </a-col>
              </a-row>
            </a-card>
            <a-card class="m-top d-flex flex-column nowrap" title="Detil Jadwal Pekerjaan">
              <a-list :grid="{ gutter: 16, lg: 1 }" :dataSource="basedData.jadwal_pekerjaan" :pagination="pagination">
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a-card hoverable class="d-flex flex-column nowrap">
                    <!-- <div slot="title" class="d-flex justify-between">
                  <span class="list-title">TLC</span>
                  <a-tag>{{item.c_proyek}}</a-tag>
                </div> -->
                    <a-list-item-meta>
                      <ul slot="description" class="list-wrapper">
                        <table style="width:100%">
                          <tr>
                            <td style="vertical-align: top;">
                              <div class="sjo" style="width:100%">
                                <a-avatar :size="52">{{ index + 1 }}</a-avatar>
                              </div>
                            </td>
                            <td style="padding-left:20px">
                              <a-row :gutter="16">
                                <a-col :xs="24" :lg="12">
                                  <li class="m-remove">
                                    <span class="list-title">Tanggal</span>
                                    <span class="list-desc">{{ item.date }}</span>
                                  </li>
                                </a-col>
                                <a-col :xs="24" :lg="12">
                                  <li class="m-remove">
                                    <span class="list-title">Estimasi Waktu</span>
                                    <span class="list-desc">{{ moment(item.start_time).format("HH:mm") }} s.d {{
                                      moment(item.end_time).format("HH:mm") }}</span>
                                  </li>
                                </a-col>
                              </a-row>
                              <a-row :gutter="16">
                                <a-col :xs="24" :lg="12">
                                  <li class="m-remove">
                                    <span class="list-title">TLC Pelaksana</span>
                                    <span class="list-desc">{{ item.pelaksana }}</span>
                                  </li>
                                </a-col>
                                <a-col :xs="24" :lg="12">
                                  <li class="m-remove">
                                    <span class="list-title">Lokasi Lembur</span>
                                    <span class="list-desc">{{ item.lokasi }}</span>
                                  </li>
                                </a-col>
                              </a-row>
                            </td>
                          </tr>
                        </table>
                      </ul>
                    </a-list-item-meta>
                  </a-card>
                </a-list-item>
              </a-list>
            </a-card>
          </a-col>
          <a-col :xs="24" :lg="12">
            <a-list itemLayout="vertical" :dataSource="datasource" :pagination="pagination2" bordered
              :class="isMobile ? 'm-top' : ''">
              <a-row slot="header" type="flex" justify="space-between">
                <h3>Detil Realisasi</h3>
                <a-button type="primary" :disabled="loading.save || basedData.spl.length == 0"
                  @click="handleTambahRealisasi"><a-icon type="plus" />&nbsp;Tambah</a-button>
              </a-row>
              <a-list-item slot="renderItem" slot-scope="item">
                <a-card style="padding:2px;">
                  <a-row :gutter="{ xs: 0, lg: 8 }">
                    <a-col :xs="24" :lg="10"><b>TLC Pelaksana</b></a-col><a-col :xs="24" :lg="14">{{ isMobile ? " " : ":"
                    }} {{ item.assignee.toString()
}}</a-col>
                    <a-col :xs="24" :lg="10"><b>Tanggal Realisasi</b></a-col><a-col :xs="24" :lg="14">{{ isMobile ? " " :
                      ":" }} {{ moment(item.date, getStandartFormatDate).format(getDefaultDateFormat) }}</a-col>
                    <a-col :xs="24" :lg="10"><b>Realisasi Waktu Sistem</b></a-col>
                    <a-col :xs="24" :lg="14">{{ isMobile ? " " : ":" }} {{ item.start_realisasi ? item.start_realisasi :
                      '-' }} s.d {{ item.end_realisasi ? item.end_realisasi : '-' }} <b>({{ realisasijam(item.date,
    item.start_realisasi, item.end_realisasi) }})</b></a-col>
                    <a-col :xs="24" :lg="10"><b>Realisasi Waktu Manual</b></a-col>
                    <a-col :xs="24" :lg="14">{{ isMobile ? " " : ":" }} {{ item.start_realisasi_user }} s.d {{
                      item.end_realisasi_user }} <b>({{ realisasijam(item.date, item.start_realisasi_user,
    item.end_realisasi_user) }})</b></a-col>
                    <a-col :xs="24" :lg="10"><b>Catatan</b></a-col><a-col :xs="24" :lg="14">{{ isMobile ? " " : ":" }} {{
                      item.catatan }}</a-col>
                  </a-row>
                  <div slot="actions">
                    <a-button-group>
                      <a-button size="small" type="default" icon="edit" @click="ubahDetil(item.key)"
                        :loading="loading.modalpage">Ubah</a-button>
                      <a-button size="small" type="danger" icon="delete" @click="hapusDetil(item.key)">Hapus</a-button>
                    </a-button-group>
                  </div>
                </a-card>
              </a-list-item>
            </a-list>
          </a-col>
        </a-row>
        <div slot="actions" style="width:100%;display: flex;justify-content: space-between;">
          <div>&nbsp;</div>
          <a-button type="primary" :disabled="datasource.length == 0" :loading="loading.save"
            @click="handleSimpanRealizeSPL">Simpan</a-button>
        </div>
        <!-- :disabled="datasource.length == 0" -->
      </a-card>
    </a-spin>

    <a-modal v-model="mjadwal" v-if="this.mjadwal" @cancel="handleCanceljadwal" :maskClosable="false">
      <span slot="title">
        <a-icon type="form" />&nbsp;Realisasi
      </span>

      <a-spin tip="Halaman sedang diproses!..." :spinning="loading.modalpage">
        <a-form class="m-form" :form="formRealize">
          <a-row :gutter="{ xs: 0, lg: 12 }">
            <a-col :xs="24" :lg="12">
              <a-form-item label="TLC">
                <a-select placeholder="Please select" showSearch :filter-option="filterOption" v-decorator="[
                  'assignee',
                  {
                    rules: [{ required: true, }], initialValue: datamodal.assignee,
                  },
                ]" ref="assignee_dtl" @change="changeAssignee">
                  <a-select-option v-for="user in assignee" :key="user.tlc">{{ user.tlc }} - {{ user.nama
                  }}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Tanggal">
                <a-date-picker placeholder="Pilih Tanggal" :format="getDefaultDateFormat" v-decorator="[
                  'date',
                  {
                    rules: [{ required: true }], initialValue: datamodal.date,
                  },
                ]" class="w-full" @change="changeTglRealize" :disabled="loading.logabsenLoading">
                  <a-icon slot="suffixIcon" type="loading" v-if="loading.logabsenLoading" />
                </a-date-picker>
              </a-form-item>
            </a-col>
            <a-col :xs="24" :lg="12">
              <a-divider orientation="left" :class="isMobile ? 'm-top' : 'm-remove'">Log Absensi</a-divider>
              <a-config-provider>
                <template v-if="basedData.logHistory" #renderEmpty>
                  <div style="text-align: center;">
                    <p>Tidak Ada Absensi</p>
                  </div>
                </template>
                <a-table :columns="columnslogHistory" :dataSource="basedData.logHistory" :pagination="false"
                  :scroll="{ y: 106 }" :rowKey="(record, index) => { return index; }" size="small" bordered>
                  <template slot="no" slot-scope="value, item, index">
                    {{ (index + 1) }}
                  </template>

                </a-table>
              </a-config-provider>
            </a-col>
          </a-row>
          <a-row :gutter="{ xs: 0, lg: 12 }">
            <a-col :xs="24" :lg="12">
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-form-item-label">
                  <label for="realisasi manual" title="Realisasi Manual"
                    :class="isMobile ? 'ant-form-item-required m-top' : 'ant-form-item-required'">Realisasi Manual</label>
                </div>
                <a-row :gutter="{ xs: 0, lg: 8 }">
                  <a-col :xs="24" :lg="11">
                    <a-form-item>
                      <a-time-picker v-decorator="[
                        'start_realisasi_user',
                        {
                          rules: [{ required: true }], initialValue: datamodal.start_realisasi_user,
                        },
                      ]" format="HH:mm" placeholder="Awal" class="w-full" @change="changeStartTime"
                        ref="start_realisasi_user" />
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="2" style="text-align: center;">
                    <span>~</span>
                  </a-col>
                  <a-col :xs="24" :lg="11">
                    <a-form-item>
                      <a-time-picker v-decorator="[
                        'end_realisasi_user',
                        {
                          rules: [{ required: true }], initialValue: datamodal.end_realisasi_user,
                        },
                      ]" format="HH:mm" placeholder="Akhir" class="w-full" @change="changeEndTime"
                        ref="end_realisasi_user" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-tag color="green" class="w-full" style="text-align:center;font-size:100%;"><span>{{ total_jam
                }}</span></a-tag>
              </div>
            </a-col>
            <a-col :xs="24" :lg="12">
              <div class="ant-row ant-form-item">
                <div class="ant-col ant-form-item-label">
                  <label for="tgl_document" title="Realisasi Sistem" class="ant-form-item">Realisasi Sistem</label>
                </div>
                <a-row :gutter="{ xs: 0, lg: 8 }">
                  <a-col :xs="24" :lg="11">
                    <a-form-item>
                      <a-time-picker v-decorator="[
                        'start_realisasi',
                        {
                          rules: [{ required: false }], initialValue: datamodal.start_realisasi,
                        },
                      ]" format="HH:mm" placeholder="Awal" class="w-full" :disabled="true" />
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :lg="2" style="text-align: center;">
                    <span>~</span>
                  </a-col>
                  <a-col :xs="24" :lg="11">
                    <a-form-item>
                      <a-time-picker v-decorator="[
                        'end_realisasi',
                        {
                          rules: [{ required: false }], initialValue: datamodal.end_realisasi,
                        },
                      ]" format="HH:mm" placeholder="Akhir" class="w-full" :disabled="true" />
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-tag color="green" class="w-full" style="text-align:center;font-size:100%;"><span>{{ total_jam_system
                }}</span></a-tag>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="{ xs: 0, lg: 12 }">
            <a-col :xs="24" :lg="24">
              <!-- :validateStatus="prefixLength.validateStatus" -->
              <!-- :help="prefixLength.errorMsg" -->
              <a-form-item label="Catatan">
                <a-textarea placeholder="Isi Catatan ... " :autoSize="{ minRows: 2, maxRows: 3 }"
                  v-decorator="['catatan', { rules: [{ required: false }], initialValue: datamodal.catatan }]" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>

      <div slot="footer" class="w-full">
        <a-button type="primary" @click="handleSimpanRealisasi">Simpan</a-button>
      </div>
    </a-modal>
  </a-layout-content>
</template>

<script>
import axios from "axios";
import { mapGetters, } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "create_Realisasi_SPL",
  props: ["id"],
  components: {},
  data() {
    return {
      mode: '',
      datasource: [],
      pagination: {
        onChange: page => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 3,
        size: "default"
      },
      pagination2: {
        onChange: page => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 3,
        size: "default"
      },
      basedData: {
        splList: null,
        spl: [],
        jadwal_pekerjaan: [],
        logHistory: [],
      },
      mjadwal: false,
      assignee: [],
      datamodal: [],
      loading: {
        save: false,
        page: false,
        splLoading: false,
        logabsenLoading: false,
        modalpage: false
      },
      kode_proyek: null,
      initialAsignTLC: [],
      filterPelaksana: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.nama.toLowerCase().indexOf(temp) > -1 ||
          option.tlc.toLowerCase().indexOf(temp) > -1
      },
      columnslogHistory: [
        {
          title: "#",
          scopedSlots: { customRender: "no" },
          align: "right",
          width: "35px"
        },
        {
          title: "Log. Absensi",
          dataIndex: "timestamp",
          align: "center",
        },
      ],
      total_jam: "-",
      total_jam_system: "-",
      urllogabsen: "Realisasi_spl/log_absensi"
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formRealize = this.$form.createForm(this);
    this.$store.dispatch("FETCH_KARYAWAN");
  },
  created() {
  },
  mounted() {
    this.fetchData();
    this.mode = this.$route.meta.isCreate ? 'Create' : 'Edit';
    if (this.mode == 'Edit')
      this.fetchEditData();
    Event.$on("confirmMessageSave", this.handleProcesSimpanRealizeSPL);

  },
  beforeDestroy() {
    Event.$off("confirmMessageSave", this.handleProcesSimpanRealizeSPL);
  },
  watch: {},
  computed: {
    ...mapGetters([
      "getAuth",
      "getKaryawan",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    projectCode() {
      let output = this.basedData.kode_project;
      return output;
    },
  },
  methods: {
    moment,
    async fetchData() {
      const dataspl = await axios.get(this.$serviceUrl + "Realisasi_spl/no_spl", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {}
      });

      Promise.all([dataspl]).then(response => {
        this.basedData.splList = response[0].data.data;
        this.loading.page = false
      });
    },
    async fetchEditData() {
      this.loading.page = true
      const spl = await axios.get(this.$serviceUrl + "Realisasi_spl/edit", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          realisasi_spl_id: this.id
        }
      });

      const mstr = await axios.get(this.$serviceUrl + "rekap_alokasi/master", {
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        },
        params: {
          tlc: this.getAuth.username
        }
      });

      Promise.all([spl, mstr]).then(response => {
        let assign = [];
        for (let i = 0; i < response[0].data.assignee.length; i++) {
          assign.push(_.filter(this.getKaryawan, (item) => item.tlc == response[0].data.assignee[i])[0])
        }
        this.basedData = {
          assignee: assign,
          splList: response[0].data.data_spl,
          spl: response[0].data.data_spl[0],
          jadwal_pekerjaan: response[0].data.jadwal_pekerjaan,
          logHistory: [],
        };
        this.datasource = [];
        for (let i = 0; i < response[0].data.start_realisasi.length; i++) {
          this.datasource.push({
            key: i,
            date: moment(response[0].data.date[i], "YYYY-MM-DD").format("YYYY-MM-DD"),
            assignee: response[0].data.assignee[i],
            start_realisasi: moment(response[0].data.start_realisasi[i]).format("HH:mm"),
            start_realisasi_user: moment(response[0].data.start_realisasi_user[i]).format("HH:mm"),
            end_realisasi: moment(response[0].data.end_realisasi[i]).format("HH:mm"),
            end_realisasi_user: moment(response[0].data.end_realisasi_user[i]).format("HH:mm"),
            catatan: response[0].data.catatan[i],
          })
        }
        this.$nextTick(() => {
          this.form.setFieldsValue({
            spl_id: response[0].data.spl_id,
          })
        })
        this.loading.page = false
      });
    },
    handleTambahRealisasi() {
      this.datamodal = [],
        this.assignee = [];
      const tassign = this.basedData.assignee;
      // if (tassign == null) {
      //   this.displayMessageValue('error-basic', 'Kepada TLC tidak boleh kosong!');
      // } else {
      this.mjadwal = true;
      for (let i = 0; i < tassign.length; i++) {
        this.assignee.push(
          this.getKaryawan.filter(
            (item) => item.tlc == tassign[i].tlc)[0]
        )
      }
      // }
    },
    handleCanceljadwal() {

    },
    handleSimpanRealisasi() {
      this.formRealize.validateFields((err, values) => {
        if (err) {
          this.displayMessage('uncompleteInput');
          return;
        }

        if (this.datamodal.length == 0) {
          let tempdata = {
            key: this.datasource.length,
            date: values.date.format(this.getStandartFormatDate),
            start_realisasi: values.start_realisasi ? moment(values.start_realisasi).format("HH:mm") : null,
            end_realisasi: values.end_realisasi ? moment(values.end_realisasi).format("HH:mm") : null,
            start_realisasi_user: moment(values.start_realisasi_user).format("HH:mm"),
            end_realisasi_user: moment(values.end_realisasi_user).format("HH:mm"),
            assignee: values.assignee,
            catatan: values.catatan,
          }
          this.datasource.push(tempdata)

          this.displayMessage('success-add')
          this.formRealize.resetFields()
          this.basedData.logHistory = [];
          this.total_jam = "-"
          this.total_jam_system = "-"
          this.$refs.assignee.focus()
        } else {
          let index = _.findIndex(this.datasource, (e) => {
            return e.key == this.datamodal.key;
          });
          this.datasource[index].date = values.date.format(this.getStandartFormatDate);
          this.datasource[index].start_realisasi = values.start_realisasi ? moment(values.start_realisasi).format("HH:mm") : null;
          this.datasource[index].end_realisasi = values.end_realisasi ? moment(values.end_realisasi).format("HH:mm") : null;
          this.datasource[index].start_realisasi_user = moment(values.start_realisasi_user).format("HH:mm");
          this.datasource[index].end_realisasi_user = moment(values.end_realisasi_user).format("HH:mm");
          this.datasource[index].assignee = values.assignee.toString();
          this.datasource[index].catatan = values.catatan;

          this.mjadwal = false;
          this.datamodal = []
          this.displayMessage('success-edit')
        }
      });
    },
    handleSimpanRealizeSPL() {
      this.confirmMessageValue('confirm-save', true)
    },
    handleProcesSimpanRealizeSPL() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage('uncompleteInput');
          return;
        }
        this.loading.save = true;

        let postData = new FormData();

        if (this.mode == "Edit") {
          postData.append("realisasi_spl_id", this.id);
        }

        postData.append("spl_id", values.spl_id);

        this.datasource.forEach(element => {
          postData.append("date[]", element.date);
          if (element.start_realisasi) {
            postData.append("start_realisasi[]", element.date + " " + element.start_realisasi + ":00");
          } else {
            postData.append("start_realisasi[]", "0000-00-00 00:00:00");
          }
          if (element.end_realisasi) {
            postData.append("end_realisasi[]", element.date + " " + element.end_realisasi + ":00");
          } else {
            postData.append("end_realisasi[]", "0000-00-00 00:00:00");
          }
          postData.append("start_realisasi_user[]", element.date + " " + element.start_realisasi_user + ":00");
          postData.append("end_realisasi_user[]", element.date + " " + element.end_realisasi_user + ":00");
          postData.append("assignee[]", element.assignee);
          postData.append("catatan[]", element.catatan);
        });

        axios({
          method: "post",
          url: this.$serviceUrl + (this.mode == "Edit" ? "Realisasi_spl/edit" : "Realisasi_spl"),
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(() => {
            this.loading.save = false;
            this.displayMessage("success-save")
            this.$router.push({
              name: "realisasi-spl",
            });
          })
          .catch(err => {
            err = Object.assign({}, err.response)
            if (err.data.message) {
              this.displayMessageValue("error-basic", err.data.message);
            } else {
              let response = Object.assign({}, err.response);
              this.displayMessageValue("error-other", response);
            }
            this.loading.save = false;
          });
      });
    },
    changekodeproyek(val) {
      this.form.setFieldsValue({
        kode_proyek: val,
      })
    },
    changeassignee(val) {
      this.form.setFieldsValue({
        assignee: val,
      })
    },
    hapusDetil(key) {
      this.datasource = _.filter(this.datasource, (item) => item.key != key);
    },
    ubahDetil(key) {
      this.assignee = [];
      const tassign = this.basedData.assignee;
      if (tassign == null) {
        this.displayMessageValue('error-basic', 'Kepada TLC tidak boleh kosong!');
      } else {
        for (let i = 0; i < tassign.length; i++) {
          this.assignee.push(
            this.getKaryawan.filter(
              (item) => item.tlc == tassign[i].tlc)[0]
          )
        }

        let tempfilt = _.filter(this.datasource, (item) => item.key == key);
        this.datamodal = {
          key: key,
          assignee: tempfilt[0].assignee.split(","),
          date: moment(tempfilt[0].date, this.getStandartFormatDate),
          start_realisasi: moment(tempfilt[0].date + " " + tempfilt[0].start_realisasi + ":00"),
          end_realisasi: moment(tempfilt[0].date + " " + tempfilt[0].end_realisasi + ":00"),
          start_realisasi_user: moment(tempfilt[0].date + " " + tempfilt[0].start_realisasi_user + ":00"),
          end_realisasi_user: moment(tempfilt[0].date + " " + tempfilt[0].end_realisasi_user + ":00"),
          catatan: tempfilt[0].catatan
        }
        let durasi = moment.duration(this.datamodal.end_realisasi.diff(this.datamodal.start_realisasi));
        this.total_jam_system = durasi.hours() + " jam " + durasi.minutes() + " menit"
        let durasi2 = moment.duration(this.datamodal.end_realisasi_user.diff(this.datamodal.start_realisasi_user));
        this.total_jam = durasi2.hours() + " jam " + durasi2.minutes() + " menit"


        this.loading.modalpage = true;
        axios({
          method: "get",
          url: this.$serviceUrl + this.urllogabsen,
          params: {
            assignee: tempfilt[0].assignee,
            date: this.datamodal.date.format(this.getStandartFormatDate)
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.basedData.logHistory = response.data.log_absen
            this.loading.modalpage = false;
            this.mjadwal = true;
          })
          .catch((err) => {
            this.loading.modalpage = false;
            if (err.message) {
              this.displayMessageValue("error-basic", err.message);
            } else {
              let response = Object.assign({}, err.response);
              this.displayMessageValue("error-other", response);
            }
          });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    changeSPL(id) {
      this.loading.splLoading = true;
      axios({
        method: "get",
        url: this.$serviceUrl + "Realisasi_spl/data_spl",
        params: {
          tlc: this.getAuth.username,
          spl_id: id
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.basedData.spl = response.data.data_spl[0]
          this.basedData.jadwal_pekerjaan = response.data.jadwal_pekerjaan;
          this.basedData.assignee = response.data.assignee
          this.loading.splLoading = false;
        })
        .catch(err => {
          if (err.message) {
            this.displayMessageValue("error-basic", err.message);
          } else {
            let response = Object.assign({}, err.response);
            this.displayMessageValue("error-other", response);
          }
        });
    },
    changeTglRealize(val) {
      let assignee = this.formRealize.getFieldValue("assignee");
      assignee = assignee ? assignee : this.datamodal.assignee[0]

      if (assignee) {
        this.loading.logabsenLoading = true;
        this.loading.modalpage = true
        axios({
          method: "get",
          url: this.$serviceUrl + this.urllogabsen,
          params: {
            assignee: assignee,
            date: moment(val).format(this.getStandartFormatDate)
          },
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.basedData.logHistory = response.data.log_absen
            this.formRealize.setFieldsValue({
              // start_realisasi: moment(this.basedData.logHistory[this.basedData.logHistory.length - 1].timestamp),
              // end_realisasi: moment(this.basedData.logHistory[this.basedData.logHistory.length-1].timestamp),
              start_realisasi: moment(response.data.start),
              end_realisasi: moment(response.data.end),
              start_realisasi_user: null,
              end_realisasi_user: null,
            })
            let durasi = moment.duration(moment(response.data.end).diff(moment(response.data.start)));
            this.total_jam_system = durasi.hours() + " jam " + durasi.minutes() + " menit"
            this.total_jam = "-"
            this.loading.logabsenLoading = false;
            this.loading.modalpage = false
          })
          .catch(() => {
            this.basedData.logHistory = [];
            this.formRealize.setFieldsValue({
              start_realisasi: null,
              end_realisasi: null,
              start_realisasi_user: null,
              end_realisasi_user: null,
            })
            this.total_jam_system = "-"
            this.total_jam = "-"
            this.loading.logabsenLoading = false;
            this.loading.modalpage = false
          });
      } else {
        this.displayMessageValue('error-basic', 'TLC tidak boleh kosong!');
        this.$nextTick(() => {
          this.formRealize.setFieldsValue({
            date: null,
          });
        });
      }
    },
    changeStartTime(start) {
      let end = this.$refs.end_realisasi_user.value
      if (end && start) {
        let durasi = moment.duration(end.diff(start));
        this.total_jam = durasi.hours() + " jam " + durasi.minutes() + " menit"
      } else {
        this.total_jam = "-"
      }
    },
    changeEndTime(end) {
      let start = this.$refs.start_realisasi_user.value
      if (start && end) {
        let durasi = moment.duration(end.diff(start));
        this.total_jam = durasi.hours() + " jam " + durasi.minutes() + " menit"
      } else {
        this.total_jam = "-"
      }
    },
    realisasijam(tgl, start, end) {
      let result = ""
      let start1 = moment(moment(tgl, this.getDefaultDateFormat).format(this.getStandartFormatDate) + " " + start + ":00")
      let end1 = moment(moment(tgl, this.getDefaultDateFormat).format(this.getStandartFormatDate) + " " + end + ":00")
      let durasi = moment.duration(end1.diff(start1));
      result = (start ? durasi.hours() : '0') + " jam " + (end ? durasi.minutes() : '0') + " menit"
      return result
    },
    changeAssignee() {
      this.formRealize.setFieldsValue({
        date: null,
        start_realisasi: null,
        end_realisasi: null,
      })
      this.total_jam = "-"
      this.total_jam_system = "-"
    }
  }
};
</script>

<style lang="less">
.m-select-form-half>.vs__dropdown-toggle {
  height: auto;
}

.ant-list-bordered .ant-list-item {
  padding: 2px !important;
}

.ant-list-item {
  padding: 2px 0 !important;
}
</style>